"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.find");

var _contractUserShop = require("@/api/contractUserShop");

var _cmsWorkOrder = require("@/api/cmsWorkOrder");

var _multiUserSelect = _interopRequireDefault(require("@/views/cms/common/multiUserSelect"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'ContractUserShopList',
  components: {
    UserSelect: _multiUserSelect.default
  },
  data: function data() {
    return {
      loading: false,
      submitting: false,
      searchForm: {
        shopName: '',
        userNick: ''
      },
      shopList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      // 经销商/门店
      dealerList: [],
      dealerShopList: [],
      // 人员选择器
      showUserSelect: false,
      form: {
        rowId: null,
        userName: '',
        userNick: '',
        isAll: false,
        dealerCode: '',
        shopCode: '',
        shopName: '',
        createTime: ''
      },
      rules: {
        userNick: [{
          required: true,
          message: '请选择人员',
          trigger: 'change'
        }],
        dealerCode: [{
          required: true,
          message: '请选择经销商',
          trigger: 'change'
        }],
        shopName: [{
          required: true,
          message: '请选择门店',
          trigger: 'change'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.handleSearch();
    this.loadDealerList();
  },
  methods: {
    // 搜索按钮点击（重置到第一页）
    handleSearchClick: function handleSearchClick() {
      this.currentPage = 1;
      this.handleSearch();
    },
    // 搜索
    handleSearch: function handleSearch() {
      var _this = this;

      this.loading = true;
      var params = this.buildSearchParams();
      (0, _contractUserShop.listContractUserShop)(params).then(function (response) {
        if (response.code === 200 && response.data) {
          _this.shopList = response.data.content || [];
          _this.total = response.data.totalElements || 0;
        } else {
          _this.$message.error(response.msg || '查询失败');

          _this.shopList = [];
        }
      }).catch(function (error) {
        console.error('查询失败:', error);

        _this.$message.error('网络错误，请稍后重试');

        _this.shopList = [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    // 构建搜索参数
    buildSearchParams: function buildSearchParams() {
      var params = {};
      if (this.searchForm.shopName) params.shopName = this.searchForm.shopName;
      if (this.searchForm.userNick) params.userNick = this.searchForm.userNick;
      params.page = this.currentPage - 1;
      params.size = this.pageSize;
      params.sort = 'createTime,desc';
      return params;
    },
    // 重置搜索
    resetSearch: function resetSearch() {
      this.searchForm = {
        shopName: '',
        userNick: ''
      };
      this.currentPage = 1;
      this.handleSearch();
    },
    // 分页
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.handleSearch();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.currentPage = current;
      this.handleSearch();
    },
    // 加载经销商列表
    loadDealerList: function loadDealerList() {
      var _this2 = this;

      (0, _cmsWorkOrder.queryDealer)().then(function (res) {
        if (res.code === 200) {
          _this2.dealerList = res.data || [];
        }
      }).catch(function () {
        _this2.dealerList = [];
      });
    },
    // 经销商变化：按经销商加载门店
    handleDealerChange: function handleDealerChange(dealerCode) {
      var _this3 = this;

      this.form.shopCode = '';
      this.form.shopName = '';

      if (!dealerCode) {
        this.dealerShopList = [];
        return;
      }

      (0, _cmsWorkOrder.queryDealerShopByDealer)(dealerCode).then(function (res) {
        if (res.code === 200) {
          _this3.dealerShopList = res.data || [];
        } else {
          _this3.dealerShopList = [];
        }
      }).catch(function () {
        _this3.dealerShopList = [];
      });
    },
    // 门店变化：回填门店名称
    handleShopChange: function handleShopChange(shopNo) {
      var shop = this.dealerShopList.find(function (s) {
        return s.shopNo === shopNo;
      });
      this.form.shopName = shop ? shop.shopName : '';
    },
    // 选择全部：清空经销商/门店选择
    handleIsAllChange: function handleIsAllChange(val) {
      if (val) {
        this.form.dealerCode = '';
        this.form.shopCode = '';
        this.form.shopName = '';
        this.dealerShopList = [];
      }
    },
    // 打开人员选择器
    onUserSelect: function onUserSelect() {
      this.$refs.userSelect.selectType = '客服'; // 回显已选人员

      if (this.form.userName || this.form.userNick) {
        this.$refs.userSelect.userNames = this.form.userName ? [this.form.userName] : [];
        this.$refs.userSelect.nickNames = this.form.userNick ? [this.form.userNick] : [];
      } else {
        this.$refs.userSelect.userNames = [];
        this.$refs.userSelect.nickNames = [];
      }

      this.$refs.userSelect.isFirst = true;
      this.$refs.userSelect.getDeptDatas('客服');
      this.showUserSelect = true;
    },
    // 关闭人员选择器
    onUserSelectClose: function onUserSelectClose() {
      this.showUserSelect = false;
    },
    // 人员选择回调：取第一个选中人员
    selectUserCallBack: function selectUserCallBack(user) {
      this.showUserSelect = false;
      var nickNames = Array.isArray(user.nickNames) ? user.nickNames : user.nickNames ? [user.nickNames] : [];
      var userNames = Array.isArray(user.userNames) ? user.userNames : user.userNames ? [user.userNames] : [];

      if (nickNames.length > 0) {
        this.form.userNick = nickNames[0];
        this.form.userName = userNames[0] || '';
      }
    },
    // 新增
    handleAdd: function handleAdd() {
      var _this4 = this;

      this.form = {
        rowId: null,
        userName: '',
        userNick: '',
        isAll: false,
        dealerCode: '',
        shopCode: '',
        shopName: '',
        createTime: ''
      };
      this.dealerShopList = [];
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs.shopForm && _this4.$refs.shopForm.clearValidate();
      });
    },
    // 提交
    handleSubmit: function handleSubmit() {
      var _this5 = this;

      this.$refs.shopForm.validate(function (valid) {
        if (!valid) return;
        _this5.submitting = true;
        var submitData = {
          userName: _this5.form.userName,
          userNick: _this5.form.userNick,
          shopCode: _this5.form.isAll ? 'A999' : _this5.form.shopCode,
          shopName: _this5.form.isAll ? '全部' : _this5.form.shopName
        };
        (0, _contractUserShop.addContractUserShop)(submitData).then(function (response) {
          if (response.code === 200) {
            _this5.$message.success('新增成功');

            _this5.dialogVisible = false;

            _this5.handleSearch();
          } else {
            _this5.$message.error(response.msg || '操作失败');
          }
        }).catch(function (error) {
          console.error('提交失败:', error);

          _this5.$message.error('网络错误，请稍后重试');
        }).finally(function () {
          _this5.submitting = false;
        });
      });
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this6 = this;

      this.$confirm("\u786E\u5B9A\u5220\u9664\u7528\u6237\u300C".concat(row.userNick || row.userName || '', "\u300D\u7684\u95E8\u5E97\u300C").concat(row.shopName || '', "\u300D\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _contractUserShop.delContractUserShop)([row.rowId]).then(function (response) {
          if (response.code === 200) {
            _this6.$message.success('删除成功');

            _this6.handleSearch();
          } else {
            _this6.$message.error(response.msg || '删除失败');
          }
        }).catch(function (error) {
          console.error('删除失败:', error);

          _this6.$message.error('网络错误，请稍后重试');
        });
      }).catch(function () {});
    }
  }
};
exports.default = _default;